export default "__VITE_ASSET__c6f73f9a__"